import React, { useEffect, useRef, useState } from "react";
import { httpPost } from "../../components/helpers/httpMethods";
import { setLocalItem } from "../../components/helpers/authService";
import "./signInAgain.css";

// "Please sign in again" sheet (2026-11-03). Comes up when a reader's sign-in has stopped working, over the page they were on,
// and reloads that page once they're back in, so everything that failed loads properly. Same sign-in call as the login page.
export default function ModalLogin({ open }) {
  const knownEmail = () => {
    try { return (JSON.parse(localStorage.getItem("user") || "{}") || {}).email || ""; } catch (e) { return ""; }
  };
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [problem, setProblem] = useState("");
  const sending = useRef(false);
  const passRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setEmail(knownEmail());
    setPassword("");
    setProblem("");
    setTimeout(() => { if (passRef.current && knownEmail()) passRef.current.focus(); }, 80);
  }, [open]);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (sending.current) return;
    const form = new FormData(e.target);
    const who = String(form.get("email") || "").trim();
    const pass = String(form.get("password") || "");
    if (!who) return setProblem("Enter your email or phone number.");
    if (!pass) return setProblem("Enter your password.");
    sending.current = true;
    setBusy(true);
    setProblem("");
    const res = await httpPost("auth/user_login", /^[[0-9+-]+$/.test(who) ? { phoneNumber: who, password: pass } : { email: who, password: pass });
    if (!res || res.er) {
      sending.current = false;
      setBusy(false);
      setProblem((res && res.er && res.er.message) || "Check your details and try again.");
      return;
    }
    localStorage.setItem("token", res.data.token);
    setLocalItem("user", res.data.user);
    localStorage.setItem("expiredToken", "false");
    localStorage.setItem("showModal", "false");
    window.location.reload();
  };

  // Carry on as a visitor on the same page.
  const notNow = () => {
    ["token", "user", "expiredToken", "showModal"].forEach((k) => localStorage.removeItem(k));
    window.location.reload();
  };

  return (
    <div className="rs-scrim">
      <form className="rs-sheet" role="dialog" aria-modal="true" aria-labelledby="rs-title" onSubmit={submit} noValidate>
        <div className="rs-grab" aria-hidden="true" />
        <h2 id="rs-title" className="rs-title">Please sign in again</h2>
        <p className="rs-sub">You were signed out to keep your account safe. This happens after a few days, or when you sign in on another device.</p>

        <label className="rs-label" htmlFor="rs-email">Email or phone number</label>
        <input id="rs-email" className="rs-input" name="email" type="text" inputMode="email" autoComplete="username" autoCapitalize="none" autoCorrect="off" spellCheck="false" value={email} onChange={(e) => setEmail(e.target.value)} />

        <label className="rs-label" htmlFor="rs-pass">Password</label>
        <div className="rs-pass">
          <input id="rs-pass" ref={passRef} className="rs-input" name="password" type={show ? "text" : "password"} autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button type="button" className="rs-show" onClick={() => setShow((s) => !s)} aria-pressed={show}>{show ? "Hide" : "Show"}</button>
        </div>
        <a className="rs-forgot" href="/forgot_password">Forgot your password?</a>

        {problem ? <p className="rs-problem" role="alert">{problem}</p> : null}

        <button type="submit" className="rs-go" disabled={busy}>{busy ? "Signing in…" : "Sign in"}</button>
        <button type="button" className="rs-later" onClick={notNow} disabled={busy}>Not now, keep browsing</button>
      </form>
    </div>
  );
}
